import { Component } from '@angular/core';

@Component({
  selector: 'app-form-part',
  template: `
    <div></div>
  `,
  styleUrls: []
})
export class FormPartComponent {

}
